import {
  FAQS_LIST_LOADING,
  GET_FAQS_LIST,
  GET_FAQS_LIST_ERROR,
  GET_FAQS_BY_ID_LOADING,
  GET_FAQS_BY_ID_SUCCESS,
  GET_FAQS_BY_ID_ERROR,
  DELETEING_FAQS,
  DELETE_FAQS,
  DELETE_FAQS_ERROR,
  DELETED_FAQS_LIST_LOADING,
  GET_DELETED_FAQS_LIST,
  GET_DELETED_FAQS_LIST_ERROR,
  PERMA_DELETEING_FAQS,
  PERMA_DELETE_FAQS,
  PERMA_DELETE_FAQS_ERROR,
  RESTORE_FAQS_LIST_LOADING,
  RESTORE_FAQS_LIST,
  RESTORE_FAQS_LIST_ERROR,
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const getList = (tokenData) => async (dispatch) => {
  dispatch({
    type: FAQS_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/faq/group/active`, {
      headers: {
        Authorization: `${tokenData.token_type} ${tokenData.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: GET_FAQS_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_FAQS_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const getEntityById = (tokenData, id) => async (dispatch) => {
  dispatch({
    type: GET_FAQS_BY_ID_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/faq/group/active/${id}`, {
      headers: {
        Authorization: `${tokenData.token_type} ${tokenData.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: GET_FAQS_BY_ID_SUCCESS,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_FAQS_BY_ID_ERROR,
        payload: error.response,
      });
    });
};

export const getDeletedList = (tokenData) => async (dispatch) => {
  dispatch({
    type: DELETED_FAQS_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/faq/group/deleted`, {
      headers: {
        Authorization: `${tokenData.token_type} ${tokenData.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: GET_DELETED_FAQS_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_DELETED_FAQS_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const deleteEntityById = (idList) => async (dispatch) => {
  dispatch({
    type: DELETEING_FAQS,
  });
  let bulk = { bulk: idList };
  await axios
    .post(`${BASE_URL}api/v1/admin/faq/group/bulk/delete`, bulk, {
      headers: {
        Authorization: `${localStorage.token_type} ${localStorage.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: DELETE_FAQS,
        payload: response,
      });
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: DELETE_FAQS_ERROR,
        payload: error.response,
      });
      message.error(error.response.data.message);
    });
};

export const permanentDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: PERMA_DELETEING_FAQS,
  });
  let bulk = { bulk: idList };
  await axios
    .post(`${BASE_URL}api/v1/admin/faq/group/bulk/perma-delete`, bulk, {
      headers: {
        Authorization: `${localStorage.token_type} ${localStorage.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: PERMA_DELETE_FAQS,
        payload: response,
      });
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: PERMA_DELETE_FAQS_ERROR,
        payload: error.response,
      });
      message.error(error.response.data.message);
    });
};

export const restoretDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: RESTORE_FAQS_LIST_LOADING,
  });
  let bulk = { bulk: idList };
  await axios
    .post(`${BASE_URL}api/v1/admin/faq/group/bulk/restore`, bulk, {
      headers: {
        Authorization: `${localStorage.token_type} ${localStorage.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: RESTORE_FAQS_LIST,
        payload: response,
      });
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: RESTORE_FAQS_LIST_ERROR,
        payload: error.response,
      });
      message.error(error.response.data.message);
    });
};
